export namespace CARD {
  export enum VARIANT {
    RECENT_INSIGHTS = 'RECENT_INSIGHTS',
    INSIGHT = 'INSIGHT',
    RELATED_ARTICLE = 'RELATED_ARTICLE',
  }
}

export interface CardProps {
  variant?: CARD.VARIANT;
  recentInsightsProps?: CommonTypes.RecentInsightsProps;
}
